import React, { useEffect, useState } from 'react';
import bot from '../images/happy.png';
import you from '../images/boy.png';

import master1 from '../images/master plan 1.jpeg';
import master2 from '../images/master plan 2.jpeg';
import master3 from '../images/master plan 3.jpeg';
import master4 from '../images/master plan 4.jpeg';

import floor1 from '../images/floor_plan_1.jpg';
import floor2 from '../images/floor_plan_2.jpg';
import floor3 from '../images/floor_plan_3.jpg';
import floor4 from '../images/floor_plan_4.jpg';
import Residential from './Residential';
import Commercial from './Commercial';

const FloorPlan = ({ siteId }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState([]);

     const [time] = useState(new Date());
      const [loading, setLoading] = useState(true);
      const [showFrame, setShowFrame] = useState(false);
    
      useEffect(() => {
        setTimeout(() => setLoading(false), 1000);
      }, []);
    
      const handleShowFrame = () => {
        setShowFrame(true);
      }

  useEffect(() => {
    let selectedImages = [];

    switch (siteId) {
      case 1:
        selectedImages = [master1, floor1];
        break;
      case 2:
        selectedImages = [master2, floor2];
        break;
      case 3:
        selectedImages = [master3, floor3];
        break;
      case 4:
        selectedImages = [master4, floor4];
        break;
      default:
        selectedImages = [];
    }

    setImages(selectedImages);
    setCurrentIndex(0); // Reset when siteId changes
  }, [siteId]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  if (images.length === 0) {
    return <div>No floor plans available for this site.</div>;
  }

  const currentImage = images[currentIndex];

  return (

    <>

<div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time.toLocaleTimeString()}
      </div>

      <div className="you-message">
        <div className="frame2">Live Images</div>
      </div>

      <div className="chatbot">
        <img src={bot} alt="bot" className="bot" />
        <div className="chatbot-time">{time.toLocaleTimeString()}</div>
      </div>

    <div className="carousel-container">
      <div className="image-container">
        <img
          src={currentImage}
          alt={`Plan ${currentIndex + 1}`}
          className="carousel-image"
        />
      </div>

      <div className="carousel-controls">
        <button
          onClick={() =>
            setCurrentIndex(currentIndex === 0 ? images.length - 1 : currentIndex - 1)
          }
          className="nav-button left"
        >
          &#60;
        </button>
        <button
          onClick={() => setCurrentIndex((currentIndex + 1) % images.length)}
          className="nav-button right"
        >
          &#62;
        </button>
      </div>

      
    </div>
    <div className="frame1" style={{ marginTop: '1rem' }}>
        <b>Akaay Infra: </b> Download&nbsp;
        <a href={currentImage} download>
          Plan
        </a>
      </div>

    
    <div>
      <div className="frame1">
        It's nice to interact with you. How do you want to take it forward?<br></br>
        <div style={{textAlign: 'center'}}>
        <button className='details-button1' style={{ width: '50%',fontSize: '13px' }}  onClick={handleShowFrame}>Return to previous menu</button>
        </div>
      </div>

    </div>

    {showFrame && ( (siteId === 1 || siteId === 2)? (<Residential />) : (<Commercial />))}
    </>
  );
};

export default FloorPlan;
